module.exports = __webpack_public_path__ + "static/monitoramento-06a1746c71b293b74c8dcb3539f3ff4a.png";